import classNames from 'classnames'

import {
  useTextareaClearHandler,
  useTextareaFocusHandler,
} from '../Textarea.hooks'
import { TextareaElement } from '../TextareaElement'
import { TextareaInlineActions } from '../TextareaInlineActions'

import { TextareaInlineFieldWrap } from './TextareaInlineFieldWrap'

import * as styles from './TextareaInlineField.module.css'

function TextareaInlineField({
  autoFocus,
  className,
  clearable,
  disabled,
  error,
  helpText,
  info,
  maxLength,
  placeholder,
  ref: forwardedRef,
  showError,
  value,
  onChange,
  ...componentProps
}) {
  const { focused, handleBlur, handleFocus } =
    useTextareaFocusHandler(autoFocus)

  const { handleClear, textareaRef } = useTextareaClearHandler({
    forwardedRef,
    onBlur: handleBlur,
    onChange,
  })

  const isClearable = clearable && !disabled && value
  const allInlineActions = isClearable && info

  const textareaClassName = classNames(className, {
    [styles.allInlineActions]: allInlineActions,
    [styles.oneInlineAction]: (isClearable || info) && !allInlineActions,
  })

  const showWrapCounter = !disabled && maxLength && focused

  return (
    <TextareaInlineFieldWrap
      disabled={disabled}
      error={error || showError}
      helpText={helpText}
      maxLength={maxLength}
      value={value}
      withCounter={showWrapCounter}
    >
      <TextareaElement
        {...componentProps}
        className={textareaClassName}
        disabled={disabled}
        error={error || showError}
        focused={focused}
        maxLength={maxLength}
        placeholder={placeholder}
        ref={textareaRef}
        value={value}
        onBlur={handleBlur}
        onChange={onChange}
        onFocus={handleFocus}
      >
        <TextareaInlineActions
          clearable={isClearable}
          info={info}
          onClear={handleClear}
        />
      </TextareaElement>
    </TextareaInlineFieldWrap>
  )
}

export default TextareaInlineField
